/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 9/24/20
 */

function SystemLoginController (
    this: JS5Object,
    _: JS5Object,
    loginService: JS5Object,
    LoginEditService: JS5Object,
) {
    this.login = () => {
        loginService.login(this.username, this.password)
            .then(() => {
                LoginEditService.removeError('systemAuthFailed');
                LoginEditService.navigateToApp();
            }, () => {
                LoginEditService.setError('systemAuthFailed', 'Could not login.  Try again.');
            });
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.username = '';
        this.password = '';
        loginService.useLocalStorage(true);
    };

    this.$onDestroy = () => {
        LoginEditService.removeError('systemAuthFailed');
    };
}

angular
.module('prism-ui.login')
.component('systemLogin', {
    controller: SystemLoginController,
    templateUrl: 'login/components/systemLogin/system-login-template.html',
    bindings: {
        canSubmit: '<',
    }
});
